<nav class="navbar navbar-expand-lg" data-bs-theme="dark">
  <button mat-button class="home-button" routerLink="grocy">Skye App</button>

  <button
    class="navbar-toggler"
    type="button"
    data-bs-toggle="collapse"
    data-bs-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav collapse collapse-horizontal show menu-options" id="menuOptions">
      @for (item of navItems; track item) {
        <li class="nav-item" [ngClass]="{ 'b-nav-dropdown dropdown': item.children !== undefined }">
          @if (item.children) {
            <a
              mat-button
              class="nav-link dropdown-toggle"
              [matMenuTriggerFor]="menu.childMenu"
              role="button"
              aria-expanded="false"
              [ngClass]="{ active: currentModule === item.module }">
              <span class="pe-1">
                <app-menu-item-display-value [item]="item" />
              </span>
            </a>

            <app-menu-item #menu [items]="item.children" />
          } @else {
            <a
              mat-button
              class="nav-link"
              [ngClass]="{ active: currentModule === item.module }"
              [routerLink]="item.route"
              [queryParams]="item.queryParams">
              <app-menu-item-display-value [item]="item" />
            </a>
          }
        </li>
      }
    </ul>
  </div>
</nav>
